import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaSortUp, FaSortDown, FaMap, FaArrowDownAZ, FaArrowUpZA, FaClock, FaAddressCard } from "react-icons/fa6";
import SupportFilterList from "./SupportFilterList";
import Slider from "@mui/material/Slider"; // Ensure you have @mui/material installed
import AdvSearchFilterList from "./AdvSearchFilterList";

const SupportFilters = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  // Get current sort order and orderby from URL
  const currentSort = searchParams.get("sort") || "asc";
  const currentOrderBy = searchParams.get("orderby") || "distance";

  // Get current radius or default to 25
  const currentRadius = parseInt(searchParams.get("radius") || "25", 10);

  // Determine the next sort order for toggling
  const nextSort = currentSort === "asc" ? "desc" : "asc";

  // Helper function to build a link with updated orderby and sort params
  const buildLink = (orderby, sort) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("orderby", orderby);
    newParams.set("sort", sort);
    return `${location.pathname}?${newParams.toString()}`;
  };

  // Check if current orderby matches and apply styles
  const isLastUpdatedActive = currentOrderBy === "last_updated";
  const isDistanceActive = currentOrderBy === "distance";
  const isNameActive = currentOrderBy === "name";
  const isPremiumActive = currentOrderBy === "premium";

  // Handler for slider changes
  const handleRadiusChange = (event, newValue) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("radius", String(newValue));
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };

  return (
    <div className="">
      <section id="sort-options" className="flex flex-col mb-2">
        <div className="font-bold text-lg font-mont mb-2">Sort Results:</div>

        <div className="flex flex-col space-y-2">
          {/* last Updated Sort Link */}
          <Link to={buildLink("last_updated", isLastUpdatedActive ? nextSort : "asc")} className={`flex py-1 px-2 text-primaryBlue items-center ${isLastUpdatedActive ? "font-bold bg-gray-200 rounded-md " : ""}`}>
            <FaClock className="mr-2" />
            <span className={`${isLastUpdatedActive ? "hover:no-underline" : "hover:underline"}`}>Last Updated</span>
            {isLastUpdatedActive && currentSort === "asc" && <FaSortUp className="ml-2" />}
            {isLastUpdatedActive && currentSort === "desc" && <FaSortDown className="ml-2" />}
          </Link>

          {/* Premium Sort Link 
          <Link to={buildLink("premium", isPremiumActive ? nextSort : "asc")} className={`flex py-1 px-2 text-primaryBlue items-center ${isPremiumActive ? "font-bold bg-gray-200 rounded-md " : ""}`}>
            <FaAddressCard className="mr-2" />
            <span className={`${isPremiumActive ? "hover:no-underline" : "hover:underline"}`}>Has Profile</span>
            {isPremiumActive && currentSort === "asc" && <FaSortUp className="ml-2" />}
            {isPremiumActive && currentSort === "desc" && <FaSortDown className="ml-2" />}
          </Link>*/}

          {/* Distance Sort Link */}
          <Link to={buildLink("distance", isDistanceActive ? nextSort : "asc")} className={`flex py-1 px-2 text-primaryBlue items-center ${isDistanceActive ? "font-bold bg-gray-200 rounded-md " : ""}`}>
            <FaMap className="mr-2" />
            <span className={`${isDistanceActive ? "hover:no-underline" : "hover:underline"}`}>Distance</span>
            {isDistanceActive && currentSort === "asc" && <FaSortUp className="ml-2" />}
            {isDistanceActive && currentSort === "desc" && <FaSortDown className="ml-2" />}
          </Link>

          {/* Name (A-Z) Sort Link */}
          <Link to={buildLink("name", isNameActive ? nextSort : "asc")} className={`flex py-1 px-2 text-primaryBlue items-center ${isNameActive ? "font-bold bg-gray-200 rounded-md " : ""}`}>
            {isNameActive && currentSort === "asc" && <FaArrowDownAZ className="mr-2" />}
            {isNameActive && currentSort === "desc" && <FaArrowUpZA className="mr-2" />}
            {!isNameActive && <FaArrowDownAZ className="mr-2" />} {/* Default icon when not active */}
            <span className={`${isNameActive ? "hover:no-underline" : "hover:underline"}`}>Name</span>
          </Link>
        </div>

        <div className="font-bold text-lg font-mont mb-2 mt-2 border-t border-gray-500 pt-2">Radius:</div>
        <div className="px-2">
          <Slider
            value={currentRadius}
            min={5}
            max={100} // Adjust ranges as needed
            step={5}
            onChangeCommitted={handleRadiusChange}
            color="primary"
          />
          <div className="text-sm mt-1">Current: {currentRadius} miles</div>
        </div>

        {/* Loop through the taxonomy list and display each one as a clickable link that I can click and filter results by that link. Clicking more will add to the filter so I can filter by multiple taxonomies. */}
        <div className="font-bold text-lg font-mont mb-2 mt-2 border-t border-gray-500 pt-2">Filter:</div>
        <SupportFilterList />

        <div className="font-bold text-lg font-mont mb-2 mt-2 border-t border-gray-500 pt-2">Advanced Search:</div>
        <AdvSearchFilterList />
      </section>
    </div>
  );
};

export default SupportFilters;
